// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3R_c6","alert":"SettungsInbox_alert__1_sHC"};